import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Typography from "@mui/material/Typography";
import { CssTextField } from "./CommonStyles";

function DatePickerField({
  label,
  value,
  onChange,
  minDate,
  disabled,
  error,
  errorMsg,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        label={
          <span style={{ fontSize: 12 }}>
            {label}
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        minDate={minDate ? dayjs(minDate) : undefined}
        onChange={(newVal) => onChange(newVal ? newVal.toDate() : null)}
        renderInput={(params) => (
          <CssTextField {...params} fullWidth variant="standard" />
        )}
        value={value ? dayjs(value) : null}
        sx={{ marginLeft: 2, width: "100%" }}
        disabled={disabled}
      />
      {error && (
        <Typography style={{ color: "red" }} variant="subtitle2">
          {errorMsg}
        </Typography>
      )}
    </LocalizationProvider>
  );
}

export default DatePickerField;
